/* @ngInject */
export default function uiRouterInterceptor(oauthConfig, $transitions, OAuthUserService) {
  $transitions.onStart({}, transition => {
    const $state  = transition.router.stateService
    const toState = transition.$to()
    const toParams = transition.params()
    const stateIsProtected = typeof toState.role !== 'undefined'
    const userIsLogged     = OAuthUserService.userIsLogged()
    const userCanEnterState = OAuthUserService.userHasRole(toState.role)

    if(!stateIsProtected) {
      return
    }
    if(!userIsLogged) {
      const redirection = JSON.stringify({
        nextState: toState.name,
        nextParams: toParams
      })
      sessionStorage.setItem('opk_oauth_temp_redirect', redirection)
      return $state.target(oauthConfig.loginState)
    }
    if(userIsLogged && !userCanEnterState) {
      return $state.target(oauthConfig.no_role_redirect)
    }
  })
}



// WEBPACK FOOTER //
// ./src/interceptors/uiRouterInterceptor.run.js